import useAppQuery from 'core/query-client/useAppQuery';
import { getProjectShares } from 'shared/api/projects/http';

export const createUseProjectSharesQueryKey = (projectId) => ['project-shares', projectId];

const useProjectSharesQuery = (projectId) =>
  useAppQuery(createUseProjectSharesQueryKey(projectId), () => getProjectShares(projectId), { enabled: !!projectId });

export default useProjectSharesQuery;
